import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

const LanguageToggle = ({ className = '' }) => {
  const { currentLanguage, toggleLanguage, availableLanguages } = useLanguage();
  const { t } = useTranslation();

  const currentLangData = availableLanguages.find(lang => lang.code === currentLanguage);
  const otherLangData = availableLanguages.find(lang => lang.code !== currentLanguage);

  return (
    <button
      onClick={toggleLanguage}
      className={`
        inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg
        bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700
        text-gray-700 dark:text-gray-300
        transition-colors duration-200
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        dark:focus:ring-offset-gray-800
        text-sm font-medium
        ${className}
      `}
      title={t('language.switchLanguage')}
      aria-label={`${t('language.switchLanguage')} - ${otherLangData?.nativeName}`}
    >
      <Globe className="h-4 w-4" />
      <span className="hidden sm:inline">
        {currentLangData?.nativeName}
      </span>
      <span className="text-xs opacity-70">
        → {otherLangData?.code.toUpperCase()}
      </span>
    </button>
  );
};

export default LanguageToggle;